import {JsonProperty} from 'json-object-mapper';

export default class Season {
  @JsonProperty() public seasonName: string;
  @JsonProperty() public seasonYear: string;

  constructor() {
    this.seasonName = null;
    this.seasonYear = null;
  }
}
